// extracted by mini-css-extract-plugin
export default {"widget__title":"Widget_widget__title__sr2cX","widget__subtitle":"Widget_widget__subtitle__jZIPO","AccordionSummary":"Widget_AccordionSummary__c+nQu"};